import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_COST_PROVIDER_RESET = 'DELETE_COST_PROVIDER_RESET';
export const DELETE_COST_PROVIDER_LOADING = 'DELETE_COST_PROVIDER_LOADING';
export const DELETE_COST_PROVIDER_SUCCESS = 'DELETE_COST_PROVIDER_SUCCESS';
export const DELETE_COST_PROVIDER_REJECT = 'DELETE_COST_PROVIDER_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteCostProviderReset = () => ({ type: DELETE_COST_PROVIDER_RESET });
export const deleteCostProviderLoading = () => ({ type: DELETE_COST_PROVIDER_LOADING });
export const deleteCostProviderSuccess = (payload) => ({ type: DELETE_COST_PROVIDER_SUCCESS, payload });
export const deleteCostProviderReject = (payload) => ({ type: DELETE_COST_PROVIDER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteCostProviderRequest = async (getState, { id, idProvider }) => {
    const options = await withToken({
        method: Methods.DELETE,
    }, getState);
    return request(`/Providers/web/DeleteProviderCosts?Id=${id}&IdProvider=${idProvider}`, options);
};